import * as SwitchPrimitive from '@radix-ui/react-switch'
import { ComponentProps, FC } from 'react'
import { styled } from '../../lib/stitches'

const StyledSwitch = styled(SwitchPrimitive.Root, {
  all: 'unset',
  width: '32px',
  minWidth: '32px',
  height: '16px',
  minHeight: '16px',
  backgroundColor: 'rgba(0,0,0,.25)',
  position: 'relative',
  boxSizing: 'border-box',
  borderRadius: '9999px',
  '&[data-state="checked"]': { backgroundColor: '#5263F4' }
})

const StyledThumb = styled(SwitchPrimitive.Thumb, {
  display: 'block',
  width: '12px',
  height: '12px',
  backgroundColor: '$gray01',
  borderRadius: '9999px',
  transition: 'transform 50ms ease',
  transform: 'translate(2px)',
  willChange: 'transform',
  '&[data-state="checked"]': { transform: 'translateX(18px)' }
})

export const SwitchRoot = StyledSwitch
export const SwitchThumb = StyledThumb

const Switch: FC<ComponentProps<typeof StyledSwitch>> = (props) => (
  <StyledSwitch {...props}>
    <StyledThumb />
  </StyledSwitch>
)

export default Switch
